<template>
  <div class="container ">
    <div class="offering-head">
      <div class="breadcrumb-list">
        <ol class="breadcrumb">
          <li aria-current="page" class="breadcrumb-item active">Employee Offerings</li>
        </ol>
      </div>
      <div class="text-right" v-if="showButton">
        <button type="button" class="btn btn-primary" @click="addOfferBtn">Add Offer</button>
      </div>
    </div>

    <div class="card" v-if="showOfferForm">
      <div class="card-body">
        <div class="row">
          <div class="col-3">
            <label>Offer Categories*</label>
            <div class="form-group">
              <select class="form-control text-capitalize" v-model="offerForm.benefit_category_id">
                <option value="">Select</option>
                <option value="" v-for="benefitCat in benefitCategories.benefit_category_details" :value="benefitCat.id"
                        class="text-capitalize">
                  {{ benefitCat.benefit_category.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-3">
            <label>Offer Title*</label>
            <div class="form-group">
              <input type="text" class="form-control" v-model="offerForm.name">
            </div>
          </div>

          <div class="col-3">
            <label>Offer Price</label>
            <div class="form-group">
              <input type="text" class="form-control" v-model="offerForm.price">
            </div>
          </div>

          <div class="col-3">
            <label>Offer Image</label>
            <div class="form-group">
              <input type="file" class="form-control" @change="onFileChange" >
            </div>
          </div>
          <div class="col-12">
            <label>Offer Description*</label>
            <div class="form-group">
              <textarea type="text" class="form-control" v-model="offerForm.description"></textarea>
            </div>
          </div>
          <div class="col-12 mt-10 float-right">
            <button class="btn btn-primary col-1" v-if="partnerOfferUpdateBtn" @click="UpdatePartnerOffer">Update</button>
            <button class="btn btn-primary col-1" v-if="partnerOfferSaveBtn" @click="savePartnerOffer">Save</button>
            <button class="btn btn-light col-1" @click="cancelBtn">Cancel</button>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="row mt-30 mb-5">
      <div class="col-12 text-right" v-if="showButton">
        <button type="button" class="btn btn-primary" @click="addOfferBtn">Add</button>
      </div>
    </div> -->
    <div class="offerings-table-wrp">
      <table class="table offerings-table">
        <thead>
        <th class="text-page">Offer Title</th>
        <th class="text-page">Offer Price</th>
        <th class="text-page">Offer Image</th>
        <th class="text-page">Offer Description</th>
        <th class="text-page">Actions</th>
        </thead>
        <tbody>
          <tr v-for="partnerOffer in partnerOffers">
          <td class="text-page text-capitalize" >{{ partnerOffer.name }}</td>
          <td class="text-page"><span v-if="partnerOffer.price">{{partnerOffer.price }} {{currencySymbol}}</span> <span></span></td>
          <td class="text-page">
            <img :src="$API_URL+'storage/'+ partnerOffer.file"  width="100" height="100" alt="image" v-if="partnerOffer.file">
            <img v-else src="/public/images/default.jpg" width="100" height="100" alt="image description">
          </td>
          <td class="text-page">{{ partnerOffer.description }}</td>
          <td class="text-page">
<!--            <button class="btn-link view-btn">View</button>-->
            <button class="btn-link edit-btn" @click="edit(partnerOffer.id)">Edit</button>
            <button class="btn-link btn-delete" @click="deleteOfferItem(partnerOffer.id)">Delete</button>
          </td>
        </tr>
        <tr v-if="!partnerOffers.length">
          <td colspan="5" class="text-center text-page">No data found.</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import Header from "../common/header";
import Swal from "sweetalert2";

export default {
  name: "timesheetProjects",
  components: {
    Header,
    Multiselect,
    Swal
  },
  data() {
    return {
      currencySymbol: (this.$store.getters.getSelectedCompany.currency) ? this.$store.getters.getSelectedCompany.currency.symbol : 'PKR',
      company_id: this.$store.getters.getSelectedCompany.id,
      partnerOffers: [],
      benefitCategories: [],
      offerForm: {
        company_id: this.$store.getters.getSelectedCompany.id,
        benefit_category_id: '',
        id: '',
        name: '',
        price: '',
        file: '',
        description: '',
      },
      showOfferForm: false,
      showButton: true,
      partnerOfferUpdateBtn: true,
      partnerOfferSaveBtn: false,
    }
  },
  created() {
    this.getPartnerBenefitCategories();
    this.getPartnerOffers();
  },
  computed: {},
  mounted() {
    // this.getPartnerOffers();
  },
  methods: {
    onFileChange(event){
      this.offerForm.file = event.target.files[0];
    },
    addOfferBtn(){
      this.showOfferForm= true;
        this.showButton= false;
      this.partnerOfferUpdateBtn= false;
      this.partnerOfferSaveBtn= true;
    },
    cancelBtn(){
      this.showOfferForm= false;
      this.showButton= true;
      this.resetForm();
      this.getPartnerOffers();
    },
    edit(id) {
      this.offerForm = this.partnerOffers.filter((item) => {
        if (item.id==id) {
          return  item;
        }
      })[0];
      this.showOfferForm= true;
      this.showButton= false;
      //// action form btn
      this.partnerOfferUpdateBtn= true;
      this.partnerOfferSaveBtn= false;
    },
    deleteOfferItem(id){
      this.$axios.delete(this.$CompanyProductItems+'/'+id, {
        headers: this.getAuthHeader(),
      }).then(res => {
        if (res.data.status === 200) {
          this.getPartnerOffers();
        }
      });
    },
    savePartnerOffer() {
      let formData = new FormData();
      formData.append("company_id", this.offerForm.company_id);
      formData.append("benefit_category_id", this.offerForm.benefit_category_id);
      formData.append("name", this.offerForm.name);
      formData.append("price", this.offerForm.price);
      formData.append("file", this.offerForm.file);
      formData.append("description", this.offerForm.description);
      this.$axios.post(this.$CompanyProductItems, formData, {
        headers: this.getAuthHeader(),
      }).then(res => {
        if (res.data.status === 200) {
          this.resetForm();
          this.getPartnerOffers();
        }
      });
    },
    UpdatePartnerOffer() {
      let formData = new FormData();
      formData.append("id", this.offerForm.id);
      formData.append("company_id", this.offerForm.company_id);
      formData.append("benefit_category_id", this.offerForm.benefit_category_id);
      formData.append("name", this.offerForm.name);
      formData.append("price", this.offerForm.price);
      formData.append("file", this.offerForm.file);
      formData.append("description", this.offerForm.description);
      this.$axios.post(this.$CompanyProductItems+'/update',formData,{
        headers: this.getAuthHeader(),
      }).then(res => {
        if (res.data.status === 200) {
          this.resetForm();
          this.getPartnerOffers();
        }
      });
    },
    getPartnerOffers() {
      let params = {
        company_id: this.company_id,
      };
      this.$axios.get(this.$CompanyProductItems, {
        params: params,
        headers: this.getAuthHeader(),
      }).then(res => {
        if (res.data.status === 200) {
          this.partnerOffers = res.data.result;
        }
      });
    },
    //get benefits
    getPartnerBenefitCategories() {
      let params = {
        company_id: this.company_id,
      };
      this.$axios
        .get(this.$Partners + '/benefits', {
          params: params,
          headers: this.getAuthHeader(),
        })
        .then((response) => {
          this.benefitCategories = response.data.result || [];
        });
    },

    // reset form data
    resetForm() {
      this.offerForm.benefit_category_id = '';
      this.offerForm.name = '';
      this.offerForm.price = '';
      this.offerForm.image = '';
      this.offerForm.description = '';
    },
    // delete
    deleteProjects(id) {
      new Swal({
        title: "Delete Projects?",
        icon: "warning",
        text: "Are you sure? You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!"
      }).then((result) => {
        if (result.value) {
          this.$axios.delete(this.$DeleteProject, {
            params: {
              id: id
            },
            headers: this.getAuthHeader(),
          }).then(res => {
            if (res.data.status === 200) {

            }
          });
        }
      });
    },


  }
}
</script>
<style scoped>
.shadow-wrp{
  box-shadow: 0 0 10px rgba(0,0,0,.1);
  border-radius: 8px;
  overflow: hidden;
}
.shadow-wrp .table{
  border: 0;
}
.shadow-wrp .table th{
  background: white;
  border: 0;
}
.shadow-wrp .table td{
  background: white !important;
  border: 0;
}




.table-striped > tbody > tr:nth-child(odd) > td,
.table-striped > tbody > tr:nth-child(odd) > th {
  background-color: #F7F7F7;
}

.text-page {
  font-size: 15px !important;
}

body {
  font-family: "Lato", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
}

input[type=text] {
  border-color: rgb(196, 196, 196) !important;
}
</style>
